import React, {useEffect} from "react";
import Header from "./Header";
import Footer from "./Footer";
import {checkShowMenu} from "../../Funlove/Components";

function Layouts(props) {

    const isShowMenu = () => {
        checkShowMenu();
    }

    return (
        <>
            <Header isShowMenu={isShowMenu}/>
            <div className="main-page">
                {props.children}
            </div>
            <Footer/>
            <div className="overlay" onClick={() => isShowMenu()}></div>
        </>
    )
}

export default Layouts;
